import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorSample = _resolveComponent("ColorSample")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_OutlineItemBlock = _resolveComponent("OutlineItemBlock")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Slider = _resolveComponent("Slider")!

  return (!_ctx.showDetails)
    ? (_openBlock(), _createBlock(_component_Space, {
        key: 0,
        vertical: "",
        full: ""
      }, {
        default: _withCtx(() => [
          (!_ctx.showDetails)
            ? (_openBlock(), _createBlock(_component_Fieldset, {
                key: 0,
                label: "アウトライン"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Space, { small: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createBlock(_component_ToggleButton, {
                          key: option.value,
                          name: "アウトライン",
                          "model-value": _ctx.modelValue,
                          size: "smallIcon",
                          value: option.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ColorSample, {
                              color: option.absColor
                            }, null, 8 /* PROPS */, ["color"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_Checkbox, {
            name: "立体感",
            "model-value": _ctx.posX !== 0 || _ctx.posY !== 0,
            "onUpdate:modelValue": _ctx.toggle3D
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString("立体感"))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"])
        ]),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createBlock(_component_Space, {
        key: 1,
        vertical: "",
        full: "",
        xlarge: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Fieldset, { label: "アウトライン" }, {
            default: _withCtx(() => [
              _createVNode(_component_Space, {
                vertical: "",
                full: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (color, ix) => {
                    return (_openBlock(), _createBlock(_component_OutlineItemBlock, {
                      key: ix,
                      "model-value": _ctx.absColors[ix],
                      "onUpdate:modelValue": ($event: any) => (_ctx.update(ix, $event)),
                      onRemove: ($event: any) => (_ctx.remove(ix) )
                    }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue", "onRemove"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createVNode(_component_Button, {
                    type: "dashed",
                    name: "アウトライン (追加)",
                    block: "",
                    onClick: _ctx.add
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" + アウトラインを追加 ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Fieldset, { label: "アウトライン太さ" }, {
            default: _withCtx(() => [
              _createVNode(_component_Slider, {
                "model-value": _ctx.thickness,
                block: "",
                min: 2,
                max: 12,
                step: 1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:thickness', $event)))
              }, null, 8 /* PROPS */, ["model-value"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Fieldset, { label: "アウトライン位置 (横)" }, {
            default: _withCtx(() => [
              _createVNode(_component_Slider, {
                "model-value": _ctx.posX,
                block: "",
                min: -1,
                max: 1,
                step: 0.1,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:posX', $event)))
              }, null, 8 /* PROPS */, ["model-value", "step"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Fieldset, { label: "アウトライン位置 (縦)" }, {
            default: _withCtx(() => [
              _createVNode(_component_Slider, {
                "model-value": _ctx.posY,
                block: "",
                min: -1,
                max: 1,
                step: 0.1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:posY', $event)))
              }, null, 8 /* PROPS */, ["model-value", "step"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
}